module.exports = __webpack_public_path__ + "static/media/096-cape-verde.2eeb63bc.svg";